import { CSSProperties } from 'react'

export type Icons =
  | 'cotton'
  | 'handmade'
  | 'sustainability'
  | 'washable'
  | 'wolle'
  | 'sample'
  | 'sample-2'
  | 'ar'
  | 'ar-2'
  | 'wishlist'

export type Props = {
  name: Icons
  className?: string
  viewBox?: string
  setWidth?: number
  setHeight?: number
  style?: CSSProperties
  percent?: number
}

const ProductCardIcon = ({
  name,
  className = '',
  viewBox,
  setWidth,
  setHeight = setWidth,
  style,
  percent,
}: Props) => {
  const selectIcon = () => {
    switch (name) {
      case 'cotton':
        return {
          width: 14,
          height: 12,
          icon: (
            <>
              <g clipPath="url(#clip0_390_36935)">
                <path
                  d="M9.0364 4.85671C8.91668 4.85671 8.81893 4.76425 8.81893 4.64994C8.81893 4.59086 8.84461 4.5374 8.88606 4.49988C9.28201 4.05238 9.49979 3.48465 9.49979 2.8986C9.49979 1.53038 8.3342 0.417374 6.90134 0.417374C5.46848 0.417374 4.30288 1.53038 4.30288 2.8986C4.30288 3.48731 4.52282 4.05769 4.92249 4.50609C4.96054 4.54331 4.98405 4.59411 4.98405 4.64994C4.98405 4.76425 4.88815 4.85671 4.76875 4.85671C4.70564 4.85671 4.64347 4.83042 4.60232 4.78464C4.13027 4.25974 3.87012 3.5901 3.87012 2.8986C3.86981 1.30235 5.22967 0.00354004 6.90134 0.00354004C8.57301 0.00354004 9.93287 1.30205 9.93287 2.89831C9.93287 3.5898 9.67271 4.25944 9.20066 4.78434C9.15952 4.83012 9.0995 4.85641 9.0364 4.85641V4.85671Z"
                  fill="currentColor"
                  stroke="currentColor"
                  strokeWidth="0.25"
                  strokeMiterlimit="10"
                />
                <path
                  d="M7.76744 11.9965C7.7594 11.9965 7.75136 11.9962 7.74331 11.9953C7.62453 11.9826 7.53884 11.8804 7.55214 11.7669L7.76868 9.90601C7.77672 9.83571 7.8222 9.77427 7.88901 9.74296C7.95583 9.71195 8.0344 9.71549 8.09751 9.75271C8.43129 9.94884 9.14741 10.2168 10.1948 9.80588C10.8315 9.55539 11.4331 9.06594 11.9346 8.39099C12.2634 7.94673 12.4945 7.42212 12.7181 6.91495C12.7224 6.90491 12.7271 6.89486 12.7314 6.88482C12.457 6.97343 12.1347 7.01863 11.7601 7.02158C11.5884 7.02217 11.4158 7.01567 11.2491 7.00918C10.9106 6.99588 10.5914 6.98348 10.2762 7.02779C10.0278 7.06353 9.78588 7.13708 9.55759 7.24578C9.45056 7.29688 9.32064 7.25553 9.26712 7.15332C9.21361 7.05112 9.25691 6.92706 9.36394 6.87596C9.63276 6.74747 9.91828 6.66092 10.2125 6.61868C10.5685 6.56876 10.9236 6.58235 11.267 6.59593C11.4288 6.60214 11.5958 6.60893 11.7576 6.60804C12.3379 6.60332 12.7577 6.48841 13.0401 6.25683C13.1172 6.19362 13.2301 6.19007 13.3114 6.24827C13.3928 6.30646 13.4206 6.41102 13.3782 6.49934C13.2882 6.6878 13.2013 6.88452 13.1175 7.07505C12.8848 7.6026 12.6445 8.14818 12.2881 8.62966C11.7313 9.37934 11.0826 9.90365 10.3597 10.1881C9.57522 10.4959 8.80837 10.5157 8.16464 10.2507L7.98274 11.8124C7.97037 11.9182 7.87664 11.9965 7.76775 11.9965H7.76744Z"
                  fill="currentColor"
                  stroke="currentColor"
                  strokeWidth="0.25"
                  strokeMiterlimit="10"
                />
                <path
                  d="M6.03524 11.9964C5.92635 11.9964 5.83262 11.9182 5.82024 11.8124L5.63835 10.2507C4.99462 10.5157 4.22776 10.4959 3.44328 10.1881C2.72035 9.90363 2.07136 9.37933 1.51486 8.62993C1.15819 8.14816 0.91783 7.60259 0.685516 7.07503C0.601685 6.8848 0.51507 6.68808 0.424742 6.49933C0.382672 6.41101 0.410513 6.30644 0.49156 6.24825C0.572916 6.19006 0.685516 6.19331 0.762851 6.25681C1.04528 6.4884 1.46505 6.6033 2.0463 6.60803C2.20654 6.60862 2.3742 6.60212 2.53599 6.59592C2.87935 6.58262 3.23447 6.56874 3.5896 6.61866C3.8844 6.6612 4.16992 6.74774 4.43873 6.87594C4.54576 6.92704 4.58907 7.0511 4.53556 7.15331C4.48204 7.25551 4.35212 7.29686 4.24509 7.24576C4.01679 7.13677 3.77489 7.06351 3.52587 7.02747C3.21158 6.98317 2.89204 6.99587 2.55362 7.00886C2.38719 7.01536 2.21427 7.02186 2.04352 7.02127C1.66829 7.01832 1.34596 6.97312 1.07126 6.88421C1.07559 6.89425 1.08023 6.9043 1.08456 6.91434C1.30791 7.42152 1.53929 7.94612 1.86812 8.39067C2.36925 9.06563 2.97092 9.55478 3.60785 9.80557C4.65496 10.2164 5.37108 9.94853 5.70486 9.7524C5.76797 9.71518 5.84685 9.71163 5.91336 9.74265C5.97986 9.77366 6.02534 9.8351 6.03369 9.9057L6.25023 11.7666C6.26353 11.8801 6.17784 11.9823 6.05905 11.995C6.05101 11.9958 6.04297 11.9961 6.03493 11.9961L6.03524 11.9964Z"
                  fill="currentColor"
                  stroke="currentColor"
                  strokeWidth="0.25"
                  strokeMiterlimit="10"
                />
                <path
                  d="M5.81829 9.10141C5.76663 9.10141 5.71497 9.08399 5.67352 9.04854C5.05299 8.51596 4.79902 7.63158 5.05577 6.89755C5.21941 6.43025 5.58381 6.07136 5.93646 5.72458C6.27488 5.39168 6.59443 5.07709 6.69094 4.70904C6.71507 4.61688 6.80168 4.55249 6.90098 4.55249C7.00028 4.55249 7.08968 4.61718 7.11381 4.70904C7.21001 5.07709 7.52987 5.39138 7.86829 5.72458C8.22093 6.07165 8.58565 6.43025 8.74898 6.89755C9.00573 7.63128 8.75176 8.51596 8.13123 9.04854C8.04214 9.12475 7.90541 9.11796 7.82529 9.03288C7.74548 8.94781 7.75259 8.81725 7.84168 8.74075C8.33786 8.3148 8.54203 7.6109 8.33817 7.0284C8.20609 6.65061 7.89087 6.34045 7.5574 6.01228C7.31983 5.77834 7.07669 5.53937 6.90222 5.26909C6.72775 5.53967 6.48461 5.77863 6.24704 6.01228C5.91357 6.34045 5.59835 6.65031 5.46626 7.0284C5.26241 7.6109 5.46657 8.3148 5.96275 8.74075C6.05184 8.81696 6.05896 8.94781 5.97915 9.03288C5.93646 9.07837 5.87738 9.10141 5.81798 9.10141H5.81829Z"
                  fill="currentColor"
                  stroke="currentColor"
                  strokeWidth="0.25"
                  strokeMiterlimit="10"
                />
                <path
                  d="M0.629854 5.79304C0.517873 5.79304 0.422906 5.71063 0.414244 5.60193C0.408367 5.52838 0.405273 5.45335 0.405273 5.3795C0.405273 4.64399 0.694506 3.94305 1.21946 3.40545C1.74224 2.87021 2.44939 2.54647 3.21098 2.49359C3.32915 2.48532 3.43402 2.57098 3.44268 2.68471C3.45134 2.79873 3.36163 2.89768 3.24254 2.90595C1.89443 2.99959 0.838349 4.08631 0.838349 5.3795C0.838349 5.44301 0.840824 5.5074 0.846082 5.57062C0.855053 5.68463 0.765964 5.78388 0.646558 5.79245C0.64099 5.79274 0.635422 5.79304 0.629854 5.79304Z"
                  fill="currentColor"
                  stroke="currentColor"
                  strokeWidth="0.25"
                  strokeMiterlimit="10"
                />
                <path
                  d="M13.1733 5.79304C13.1677 5.79304 13.1621 5.79304 13.1566 5.79245C13.0375 5.78389 12.9481 5.68434 12.957 5.57062C12.962 5.5074 12.9648 5.44301 12.9648 5.3795C12.9648 4.08631 11.9087 2.99959 10.5606 2.90595C10.4412 2.89768 10.3518 2.79873 10.3604 2.68471C10.3691 2.57069 10.4734 2.48532 10.5921 2.4936C11.3537 2.54647 12.0612 2.87051 12.5837 3.40545C13.1086 3.94305 13.3978 4.644 13.3978 5.3795C13.3978 5.45335 13.3948 5.52838 13.3889 5.60193C13.3802 5.71033 13.2852 5.79304 13.1733 5.79304Z"
                  fill="currentColor"
                  stroke="currentColor"
                  strokeWidth="0.25"
                  strokeMiterlimit="10"
                />
              </g>
              <defs>
                <clipPath id="clip0_390_36935">
                  <rect
                    width="13"
                    height="12"
                    fill="currentColor"
                    transform="translate(0.401367)"
                  />
                </clipPath>
              </defs>
            </>
          ),
        }
      case 'handmade':
        return {
          width: 11,
          height: 14,
          icon: (
            <>
              <g clipPath="url(#clip0_336_12803)">
                <path
                  d="M2.8999 7.00004H2.2749V1.75004C2.2749 1.10546 2.83428 0.583374 3.5249 0.583374C4.21553 0.583374 4.7749 1.10546 4.7749 1.75004V6.70837H4.1499V1.75004C4.1499 1.42921 3.86865 1.16671 3.5249 1.16671C3.18115 1.16671 2.8999 1.42921 2.8999 1.75004V7.00004Z"
                  fill="currentColor"
                />
                <path
                  d="M6.6499 6.125H6.0249V1.16667C6.0249 0.845833 5.74365 0.583333 5.3999 0.583333C5.05615 0.583333 4.7749 0.845833 4.7749 1.16667V6.125H4.1499V1.16667C4.1499 0.522083 4.70928 0 5.3999 0C6.09053 0 6.6499 0.522083 6.6499 1.16667V6.125Z"
                  fill="currentColor"
                />
                <path
                  d="M8.5249 6.70837H7.8999V1.75004C7.8999 1.42921 7.61865 1.16671 7.2749 1.16671C6.93115 1.16671 6.6499 1.42921 6.6499 1.75004V6.70837H6.0249V1.75004C6.0249 1.10546 6.58428 0.583374 7.2749 0.583374C7.96553 0.583374 8.5249 1.10546 8.5249 1.75004V6.70837Z"
                  fill="currentColor"
                />
                <path
                  d="M9.4624 14H8.8374V13.0287L8.8999 12.95C9.46553 12.247 9.7749 11.3779 9.7749 10.5V3.20829C9.7749 2.88746 9.49365 2.62496 9.1499 2.62496C8.80615 2.62496 8.5249 2.88746 8.5249 3.20829V5.54163H7.8999V3.20829C7.8999 2.56371 8.45928 2.04163 9.1499 2.04163C9.84053 2.04163 10.3999 2.56371 10.3999 3.20829V10.5C10.3999 11.4712 10.0687 12.4308 9.4624 13.2212V14Z"
                  fill="currentColor"
                />
                <path
                  d="M3.2124 14H2.5874C2.5874 13.6792 2.47803 13.3846 2.25928 13.1221L1.45303 12.1567C0.774902 11.3429 0.399902 10.325 0.399902 9.2925V4.375H1.3374C2.1999 4.375 2.8999 5.02833 2.8999 5.83333V8.28625L2.18428 8.95417L1.74365 8.54292L2.27803 8.04417V5.83042C2.27803 5.34917 1.85615 4.95542 1.34053 4.95542H1.02803V9.28667C1.02803 10.1908 1.35615 11.0804 1.9499 11.7921L2.75615 12.7575C3.05615 13.1192 3.21553 13.5479 3.21553 13.9942L3.2124 14Z"
                  fill="currentColor"
                />
              </g>
              <defs>
                <clipPath id="clip0_336_12803">
                  <rect width="10" height="14" fill="white" transform="translate(0.399902)" />
                </clipPath>
              </defs>
            </>
          ),
        }
      case 'sustainability':
        return {
          width: 13,
          height: 15,
          icon: (
            <>
              <path d="M4.67589 0.993042H4.17432V14.4117H4.67589V0.993042Z" fill="currentColor" />
              <path
                d="M3.92525 11.9139C3.66882 11.9139 2.9221 11.88 2.15156 11.5231C1.28071 11.1205 0.219879 10.2217 0.107652 8.22421C0.00796455 6.45363 0.912677 5.00055 1.76911 3.77803C2.87571 2.19672 4.15785 0.819462 4.17039 0.805899L4.52839 0.500732L4.70958 0.957557L4.53968 1.13942C4.52714 1.15299 3.26819 2.50558 2.18166 4.05792C1.37287 5.21386 0.517061 6.58186 0.607971 8.1977C0.686969 9.6064 1.2782 10.5755 2.3641 11.0774C3.18355 11.4565 3.9823 11.4201 3.99108 11.4201L4.24124 11.4072L4.26757 11.8998L4.01679 11.9127C4.01052 11.9127 3.97791 11.9146 3.92462 11.9146L3.92525 11.9139Z"
                fill="currentColor"
              />
              <path
                d="M4.98288 11.9131C4.92959 11.9131 4.89824 11.9118 4.89385 11.9112L4.64307 11.8983L4.66877 11.4057L4.91893 11.4186C4.92269 11.4186 5.31267 11.4359 5.82051 11.3206L6.06503 11.2651L6.17788 11.7454L5.93336 11.8009C5.49825 11.8995 5.14213 11.9125 4.98288 11.9125V11.9131Z"
                fill="currentColor"
              />
              <path
                d="M7.73447 5.69769L7.61848 5.47883C7.33635 4.9468 6.9934 4.43942 6.72568 4.05719C5.63978 2.50547 4.38083 1.15225 4.36766 1.13869L4.19775 0.956825L4.50434 0.5L4.73694 0.805166C4.74948 0.818729 6.03163 2.19598 7.13823 3.7773C7.41409 4.17124 7.76833 4.69527 8.063 5.25073L8.17899 5.46959L7.73447 5.69769Z"
                fill="currentColor"
              />
              <path
                d="M4.29003 6.43055C4.29003 6.43055 2.19533 4.80546 1.71884 4.43556L1.52197 4.28267L1.83295 3.89551L2.02982 4.0484C2.50631 4.4183 4.601 6.04338 4.601 6.04338L4.29066 6.43055H4.29003Z"
                fill="currentColor"
              />
              <path
                d="M4.3996 10.218L4.20147 10.067C4.19458 10.0621 3.50993 9.53926 2.6629 8.87036L2.46729 8.71624L2.7814 8.33154L2.97701 8.48567C3.82028 9.15148 4.50179 9.67181 4.50869 9.67674L4.70681 9.82778L4.3996 10.2174V10.218Z"
                fill="currentColor"
              />
              <path
                d="M1.75036 8.13145L0.271973 6.92681L0.460689 6.48047L2.06447 7.74675L1.75036 8.13145Z"
                fill="currentColor"
              />
              <path
                d="M5.23436 5.25987L4.07666 6.17383L4.39067 6.55841L5.54837 5.64445L5.23436 5.25987Z"
                fill="currentColor"
              />
              <path
                d="M6.24498 5.09322L5.93213 4.70729L6.12837 4.55378C6.6337 4.15737 6.91772 3.95393 6.92963 3.9453L7.13214 3.7998L7.42744 4.19806L7.22493 4.34356C7.22493 4.34356 6.93716 4.5507 6.44123 4.93909L6.24498 5.0926V5.09322Z"
                fill="currentColor"
              />
              <path
                d="M5.87075 8.63878L4.28369 9.81006L4.58478 10.2045L6.17184 9.03324L5.87075 8.63878Z"
                fill="currentColor"
              />
              <path d="M9.3087 5.49512H8.80713V14.5003H9.3087V5.49512Z" fill="currentColor" />
              <path
                d="M8.70593 12.7947C8.35421 12.7947 6.14039 12.6942 5.99995 10.2029C5.93036 8.96929 6.55607 7.9644 7.14792 7.11857C7.90655 6.03477 8.7586 5.11927 8.79434 5.08105L9.02694 4.77588L9.33353 5.2327L9.16425 5.41457C9.15547 5.42382 8.29966 6.34363 7.56109 7.39846C7.01626 8.17648 6.44008 9.09753 6.50089 10.1758C6.62503 12.3841 8.64136 12.3064 8.72662 12.3021L8.97741 12.2891L9.00374 12.7817L8.75358 12.7947C8.75358 12.7947 8.7354 12.7953 8.70656 12.7953L8.70593 12.7947Z"
                fill="currentColor"
              />
              <path
                d="M9.38722 12.7945C9.35838 12.7945 9.34271 12.7939 9.3402 12.7939L9.09004 12.781L9.11637 12.2884L9.36716 12.3013C9.45117 12.305 11.4694 12.3729 11.5929 10.175C11.6537 9.09678 11.0775 8.17574 10.5327 7.39772C9.79349 6.34166 8.93831 5.42308 8.93016 5.41383L8.76025 5.23196L9.12954 4.89844L9.29945 5.0803C9.33518 5.11853 10.1872 6.03403 10.9459 7.11783C11.5377 7.96305 12.1634 8.96855 12.0938 10.2022C11.9534 12.6934 9.73895 12.7945 9.38722 12.7945Z"
                fill="currentColor"
              />
              <path
                d="M7.17741 7.11261L6.86572 7.49902L9.11401 9.25249L9.42569 8.86608L7.17741 7.11261Z"
                fill="currentColor"
              />
              <path
                d="M9.02075 11.6702L6.12354 9.40643L6.31163 8.89844L9.33486 11.2861L9.02075 11.6702Z"
                fill="currentColor"
              />
              <path
                d="M8.95192 9.27223L8.67041 8.77903L10.8403 7.05469L11.157 7.43692L8.95192 9.27223Z"
                fill="currentColor"
              />
              <path
                d="M11.7378 8.9634L8.68213 11.3766L8.99621 11.7611L12.0519 9.34793L11.7378 8.9634Z"
                fill="currentColor"
              />
            </>
          ),
        }
      case 'washable':
        return {
          width: 10,
          height: 12,
          icon: (
            <>
              <path
                d="M8.78535 12H1.15828C0.740322 12 0.400391 11.6478 0.400391 11.2147V0.785345C0.400391 0.352243 0.740322 0 1.15828 0H8.78535C9.20332 0 9.54325 0.352243 9.54325 0.785345V11.2144C9.54325 11.6475 9.20332 11.9998 8.78535 11.9998V12ZM1.15828 0.363138C0.933533 0.363138 0.750835 0.552695 0.750835 0.785345V11.2144C0.750835 11.4473 0.933767 11.6366 1.15828 11.6366H8.78535C9.01011 11.6366 9.1928 11.4471 9.1928 11.2144V0.785345C9.1928 0.552453 9.00987 0.363138 8.78535 0.363138H1.15828Z"
                fill="currentColor"
              />
              <path
                d="M4.97157 9.7416C3.29154 9.7416 1.9248 8.32537 1.9248 6.58449C1.9248 4.8436 3.29154 3.42737 4.97157 3.42737C6.6516 3.42737 8.01833 4.8436 8.01833 6.58449C8.01833 8.32537 6.6516 9.7416 4.97157 9.7416ZM4.97157 3.79026C3.48475 3.79026 2.27525 5.04357 2.27525 6.58424C2.27525 8.12492 3.48475 9.37822 4.97157 9.37822C6.45839 9.37822 7.66788 8.12492 7.66788 6.58424C7.66788 5.04357 6.45839 3.79026 4.97157 3.79026Z"
                fill="currentColor"
              />
              <path
                d="M3.78509 6.76591C3.68836 6.76591 3.60986 6.68457 3.60986 6.58434C3.60986 6.08297 3.85167 5.61888 4.25655 5.34338C4.33739 5.28843 4.44602 5.31167 4.49929 5.39543C4.55232 5.47919 4.5299 5.59177 4.44906 5.64696C4.14301 5.85516 3.96031 6.20571 3.96031 6.58434C3.96031 6.68457 3.88181 6.76591 3.78509 6.76591Z"
                fill="currentColor"
              />
              <path
                d="M5.08105 8.79474C3.90495 8.79474 2.94824 7.80337 2.94824 6.58444C2.94824 5.36551 3.90495 4.37415 5.08105 4.37415C5.88146 4.37415 6.60758 4.83243 6.97602 5.57032C7.01667 5.65166 6.99237 5.75165 6.91948 5.80345C6.67066 5.98042 6.52207 6.27239 6.52207 6.58444C6.52207 6.8965 6.67066 7.18846 6.91948 7.36543C6.99237 7.41724 7.01667 7.51722 6.97602 7.59856C6.60758 8.33646 5.88146 8.79474 5.08105 8.79474ZM5.08105 4.73753C4.09817 4.73753 3.29869 5.5662 3.29869 6.58468C3.29869 7.60316 4.0984 8.43184 5.08105 8.43184C5.7018 8.43184 6.26929 8.10187 6.5938 7.56152C6.32723 7.31459 6.17186 6.96017 6.17186 6.58493C6.17186 6.20968 6.32723 5.85526 6.5938 5.60833C6.26929 5.06798 5.7018 4.73801 5.08105 4.73801V4.73753Z"
                fill="currentColor"
              />
              <path
                d="M8.62305 1.94785H1.32073C1.22401 1.94785 1.14551 1.86651 1.14551 1.76629C1.14551 1.66606 1.22401 1.58472 1.32073 1.58472H8.62305C8.71978 1.58472 8.79828 1.66606 8.79828 1.76629C8.79828 1.86651 8.71978 1.94785 8.62305 1.94785Z"
                fill="currentColor"
              />
              <path
                d="M8.51837 1.0419C8.53356 0.944902 8.46999 0.853502 8.37638 0.837756C8.28277 0.82201 8.19456 0.887881 8.17937 0.984884C8.16417 1.08189 8.22774 1.17329 8.32135 1.18903C8.41497 1.20478 8.50317 1.13891 8.51837 1.0419Z"
                fill="currentColor"
              />
            </>
          ),
        }
      case 'wolle':
        return {
          width: 11,
          height: 11,
          icon: (
            <>
              <g clipPath="url(#clip0_406_37511)">
                <path
                  d="M10.3685 5.50032C10.7688 5.12713 11 4.6043 11 4.04707C11 2.92019 10.0568 2.00379 8.92094 2.05888C8.9219 2.03595 8.92222 2.01303 8.92222 1.99042C8.92222 0.892838 8.02932 0 6.93168 0C6.3827 0 5.86493 0.225439 5.49236 0.615498C5.12011 0.225439 4.60202 0 4.05303 0C2.95539 0 2.06282 0.892838 2.06282 1.99042C2.06282 2.01303 2.06314 2.03563 2.06409 2.05824C0.938108 2.01908 0.00127374 2.92561 0.00127374 4.04707C0.00127374 4.60398 0.232139 5.12618 0.631774 5.49936C0.231183 5.87255 0 6.39539 0 6.95293C0 8.07981 0.940337 8.99302 2.07906 8.94112C2.0781 8.96405 2.07778 8.98697 2.07778 9.00958C2.07778 10.1072 2.97068 11 4.06832 11C4.6173 11 5.13507 10.7746 5.50764 10.3845C5.88021 10.7746 6.39799 11 6.94697 11C8.04461 11 8.9375 10.1072 8.9375 9.00958C8.9375 8.98697 8.93718 8.96437 8.93623 8.94176C10.0609 8.98252 10.999 8.07439 10.999 6.95293C10.999 6.39602 10.7682 5.87382 10.3685 5.50064V5.50032ZM9.00851 8.43516C8.90597 8.43516 8.80153 8.42401 8.69836 8.40204C8.61461 8.38453 8.52704 8.41 8.46622 8.47082C8.4054 8.53164 8.37928 8.61889 8.39712 8.70295C8.41845 8.80452 8.42928 8.90769 8.42928 9.00958C8.42928 9.82696 7.76407 10.4921 6.94665 10.4921C6.45371 10.4921 5.99421 10.2479 5.71781 9.83906C5.67068 9.76932 5.59171 9.72729 5.50732 9.72729C5.42294 9.72729 5.34429 9.769 5.29684 9.83906C5.02012 10.2482 4.56062 10.4921 4.06768 10.4921C3.25026 10.4921 2.58505 9.82696 2.58505 9.00958C2.58505 8.90705 2.5962 8.80229 2.61817 8.69881C2.636 8.61411 2.60989 8.52623 2.54843 8.46541C2.48697 8.40459 2.39845 8.37912 2.31438 8.3979C1.35685 8.61252 0.507266 7.8757 0.507266 6.95261C0.507266 6.45111 0.758829 5.98749 1.18012 5.71207C1.25177 5.66526 1.29507 5.58534 1.29507 5.49968C1.29507 5.41403 1.25208 5.33411 1.18044 5.2873C0.759785 5.01155 0.50854 4.54794 0.50854 4.04707C0.50854 3.22969 1.17343 2.56452 1.99085 2.56452C2.09339 2.56452 2.19783 2.57567 2.30069 2.59764C2.38507 2.61611 2.47201 2.59 2.53315 2.52918C2.59397 2.46836 2.62008 2.38111 2.60225 2.29705C2.58091 2.19548 2.57008 2.09231 2.57008 1.9901C2.57008 1.17273 3.23498 0.507555 4.0524 0.507555C4.54533 0.507555 5.00483 0.75178 5.28155 1.16063C5.32868 1.23036 5.40765 1.27239 5.49204 1.27239C5.57642 1.27239 5.65508 1.23068 5.70252 1.16063C5.97924 0.751462 6.43874 0.507555 6.93168 0.507555C7.7491 0.507555 8.41431 1.17273 8.41431 1.9901C8.41431 2.09263 8.40317 2.19739 8.3812 2.30087C8.36336 2.38557 8.38947 2.47346 8.45093 2.53427C8.51239 2.59509 8.6006 2.62056 8.68498 2.60178C9.64283 2.38716 10.4921 3.12398 10.4921 4.04707C10.4921 4.54857 10.2405 5.01219 9.81924 5.28762C9.7476 5.33442 9.70429 5.41435 9.70429 5.5C9.70429 5.58565 9.74728 5.66558 9.81893 5.71238C10.2396 5.98813 10.4908 6.45175 10.4908 6.95261C10.4908 7.76999 9.82593 8.43516 9.00851 8.43516Z"
                  fill="currentColor"
                />
                <path
                  d="M9.4432 3.78695C8.93434 3.33766 8.28251 3.08994 7.60742 3.08994C7.45712 3.08994 7.303 3.10363 7.14729 3.13038C6.69161 2.71643 6.07989 2.51965 5.50002 2.51965C4.92016 2.51965 4.30844 2.71643 3.85276 3.13038C3.69705 3.10363 3.54261 3.08994 3.39263 3.08994C2.71754 3.08994 2.06571 3.33735 1.55685 3.78695C1.5024 3.83503 1.47119 3.90444 1.47119 3.97736C1.47119 4.05028 1.5024 4.11938 1.55685 4.16777C2.0017 4.5607 2.5561 4.79919 3.13947 4.85301C3.13883 4.88039 3.13851 4.90777 3.13851 4.93516C3.13851 6.06745 3.56331 7.14751 4.33455 7.97635C4.63293 8.29699 5.05772 8.48072 5.49971 8.48072C5.94169 8.48072 6.3668 8.29699 6.66486 7.97635C7.43611 7.14751 7.8609 6.06745 7.8609 4.93516C7.8609 4.90777 7.86058 4.88039 7.85994 4.85301C8.44332 4.79919 8.99771 4.5607 9.44256 4.16777C9.49701 4.11969 9.52822 4.05028 9.52822 3.97736C9.52822 3.90444 9.49701 3.83535 9.44256 3.78695H9.4432ZM3.46841 3.5994C3.33881 3.81465 3.24137 4.06333 3.18787 4.34704C2.81371 4.31297 2.45452 4.18561 2.14118 3.97736C2.53221 3.71722 2.99586 3.58093 3.46841 3.5994ZM6.29388 7.63023C6.14677 7.78848 5.96048 7.89515 5.75445 7.94355V7.45192H6.00538C6.14581 7.45192 6.25949 7.33824 6.25949 7.19782C6.25949 7.0574 6.14581 6.94373 6.00538 6.94373H5.01728C4.87685 6.94373 4.76317 7.0574 4.76317 7.19782C4.76317 7.33824 4.87685 7.45192 5.01728 7.45192H5.24655V7.94355C5.04052 7.89547 4.85424 7.78848 4.70712 7.63023C4.02376 6.89564 3.64737 5.93849 3.64737 4.93516C3.64737 4.87402 3.64865 4.8132 3.65151 4.7527C3.65279 4.72341 3.65502 4.69475 3.65756 4.6661C3.65979 4.65591 3.6617 4.6454 3.66298 4.63489C3.70469 4.21076 3.85945 3.85668 4.1228 3.58221C4.13235 3.57202 4.14063 3.56119 4.14859 3.55005C4.50555 3.19501 5.00836 3.02816 5.50098 3.02816C5.9936 3.02816 6.49641 3.19501 6.85337 3.55005C6.86101 3.56119 6.86961 3.57234 6.87916 3.58221C7.14251 3.85668 7.29727 4.21108 7.33898 4.63489C7.33994 4.64604 7.34217 4.65686 7.3444 4.66737C7.34663 4.69539 7.34886 4.72373 7.35013 4.7527C7.353 4.8132 7.35427 4.87402 7.35427 4.93516C7.35427 5.9388 6.97788 6.89596 6.29452 7.63023H6.29388ZM7.81281 4.348C7.75932 4.06397 7.66219 3.81529 7.53227 3.59972C8.00451 3.58189 8.46847 3.71753 8.85951 3.97768C8.5449 4.1872 8.18443 4.31456 7.81281 4.34832V4.348Z"
                  fill="currentColor"
                />
                <path
                  d="M5.28767 4.73739C5.17367 4.65588 5.01509 4.68199 4.93325 4.79598C4.84313 4.92144 4.7043 4.9934 4.5524 4.9934C4.40051 4.9934 4.26167 4.92144 4.17187 4.79598C4.09035 4.68199 3.93177 4.65556 3.81746 4.73739C3.70346 4.81891 3.67735 4.9778 3.75886 5.09179C3.9426 5.34843 4.23938 5.50159 4.55272 5.50159C4.86606 5.50159 5.16252 5.34843 5.34626 5.09179C5.42778 4.9778 5.40167 4.81923 5.28767 4.73739Z"
                  fill="currentColor"
                />
                <path
                  d="M7.18301 4.73736C7.06901 4.65585 6.91043 4.68196 6.82859 4.79595C6.73847 4.92141 6.59995 4.99337 6.44774 4.99337C6.29553 4.99337 6.15701 4.92141 6.06689 4.79595C5.98537 4.68164 5.82679 4.65553 5.71248 4.73736C5.59848 4.81919 5.57237 4.97777 5.65388 5.09176C5.83762 5.3484 6.1344 5.50156 6.44774 5.50156C6.76108 5.50156 7.05754 5.3484 7.24128 5.09176C7.3228 4.97777 7.29669 4.81919 7.18269 4.73736H7.18301Z"
                  fill="currentColor"
                />
              </g>
              <defs>
                <clipPath id="clip0_406_37511">
                  <rect width="11" height="11" fill="currentColor" />
                </clipPath>
              </defs>
            </>
          ),
        }
      case 'sample':
        return {
          width: 27,
          height: 27,
          icon: (
            <>
              <rect
                x="0.50468"
                y="0.0949375"
                width="13.8266"
                height="14.1862"
                transform="matrix(0.807644 -0.58967 0.53817 0.842836 0.0459856 8.90797)"
                fill="white"
                stroke="black"
                strokeWidth="0.75"
              />
              <rect
                x="0.50468"
                y="0.0949375"
                width="13.8266"
                height="14.1862"
                transform="matrix(0.807644 -0.58967 0.53817 0.842836 3.54269 9.11537)"
                fill="white"
                stroke="black"
                strokeWidth="0.75"
              />
              <rect
                x="0.50468"
                y="0.0949375"
                width="13.8266"
                height="14.1862"
                transform="matrix(0.807644 -0.58967 0.53817 0.842836 1.60031 14.7239)"
                fill="white"
                stroke="black"
                strokeWidth="0.75"
              />
              <rect
                x="0.451644"
                y="0.260464"
                width="13.5735"
                height="14.4291"
                transform="matrix(0.961318 -0.275439 0.243065 0.97001 6.62945 7.49024)"
                fill="white"
                stroke="black"
                strokeWidth="0.75"
              />
              <rect
                x="13.001"
                y="9.09863"
                width="13.6241"
                height="14.4128"
                fill="white"
                stroke="black"
                strokeWidth="0.75"
              />
            </>
          ),
        }
      case 'ar':
        return {
          width: 21,
          height: 21,
          icon: (
            <>
              <path
                d="M3.6498 5.95887C3.57011 5.99715 3.50292 6.062 3.45995 6.14715C3.45761 6.15106 3.45605 6.15497 3.4537 6.15887C3.4498 6.16825 3.44589 6.17762 3.44276 6.187C3.42323 6.23778 3.41464 6.29012 3.4162 6.34169V9.25029C3.4162 9.47997 3.60214 9.66669 3.8326 9.66669C4.06306 9.66669 4.249 9.47997 4.249 9.25028V7.00728L6.14588 7.95572C6.35212 8.05885 6.60212 7.97526 6.70526 7.76979C6.80839 7.56355 6.72479 7.31355 6.51932 7.21041L4.76464 6.33307L6.51932 5.45573C6.72478 5.35338 6.80838 5.10261 6.70526 4.89713C6.60214 4.69089 6.35214 4.60807 6.14588 4.71041L3.6498 5.95887ZM3.4162 14.6581C3.41463 14.7198 3.42713 14.7816 3.4537 14.8409C3.47479 14.8855 3.50291 14.9261 3.53729 14.9605C3.57245 14.9956 3.60995 15.0214 3.64979 15.0409L6.14579 16.2894C6.35203 16.3925 6.60203 16.3089 6.70517 16.1034C6.80829 15.8972 6.7247 15.6472 6.51923 15.544L4.76455 14.6667L6.51923 13.7894C6.72469 13.6862 6.80829 13.4362 6.70517 13.23C6.60204 13.0245 6.35205 12.9409 6.14579 13.044L4.24891 13.9925V11.7503C4.24891 11.5198 4.06297 11.3331 3.83251 11.3331C3.60205 11.3331 3.41611 11.5198 3.41611 11.7503L3.4162 14.6581ZM16.2342 14.6667L14.4795 15.544C14.2741 15.6472 14.1905 15.8972 14.2936 16.1034C14.3959 16.3089 14.6467 16.3925 14.8522 16.2894L17.3482 15.0409C17.4279 15.0026 17.4958 14.9386 17.5388 14.8534C17.5404 14.8487 17.5427 14.8448 17.5443 14.8409C17.549 14.8315 17.5521 14.823 17.556 14.8136C17.5747 14.762 17.5833 14.7097 17.5826 14.6581V11.7503C17.5826 11.5199 17.3958 11.3331 17.1662 11.3331C16.9357 11.3331 16.749 11.5198 16.749 11.7503V13.9925L14.8521 13.0441C14.6466 12.9409 14.3959 13.0245 14.2935 13.23C14.1904 13.4362 14.274 13.6862 14.4794 13.7894L16.2342 14.6667ZM16.749 7.00726V9.25026C16.749 9.47994 16.9358 9.66666 17.1662 9.66666C17.3959 9.66666 17.5826 9.47995 17.5826 9.25026V6.34166C17.5842 6.28073 17.5717 6.21823 17.5443 6.15885C17.524 6.1151 17.4959 6.07448 17.4615 6.03932C17.4264 6.00494 17.3889 5.97838 17.3482 5.95885L14.8522 4.71041C14.6468 4.60807 14.396 4.69088 14.2936 4.89713C14.1905 5.10259 14.2741 5.35337 14.4796 5.45573L16.2343 6.33307L14.4796 7.21041C14.2741 7.31353 14.1905 7.56353 14.2936 7.76979C14.396 7.97525 14.6468 8.05885 14.8522 7.95573L16.749 7.00726ZM10.6928 2.63067C10.635 2.6002 10.5694 2.58301 10.4991 2.58301C10.4296 2.58301 10.3631 2.6002 10.3053 2.63067L7.81313 3.87755C7.60689 3.97989 7.52406 4.23067 7.62641 4.43615C7.72953 4.64239 7.97954 4.72521 8.1858 4.62286L10.0827 3.67442V5.91662C10.0827 6.14708 10.2694 6.33302 10.4991 6.33302C10.7295 6.33302 10.9163 6.14709 10.9163 5.91662V3.67442L12.8131 4.62286C13.0186 4.72521 13.2694 4.64239 13.3717 4.43614C13.4749 4.23068 13.3913 3.9799 13.1858 3.87754L10.6928 2.63067ZM10.3053 18.3689C10.3631 18.3994 10.4296 18.4166 10.4991 18.4166C10.5694 18.4166 10.635 18.3994 10.6928 18.3689L13.1858 17.1228C13.3913 17.0197 13.4749 16.7697 13.3718 16.5634C13.2694 16.358 13.0187 16.2744 12.8132 16.3775L10.9163 17.3259V15.0829C10.9163 14.8532 10.7296 14.6665 10.4991 14.6665C10.2694 14.6665 10.0827 14.8532 10.0827 15.0829V17.3259L8.18582 16.3775C7.97958 16.2744 7.72959 16.358 7.62645 16.5634C7.52411 16.7697 7.60692 17.0197 7.81317 17.1228L10.3053 18.3689ZM10.0827 9.92427V12.1665C10.0827 12.397 10.2694 12.5829 10.4991 12.5829C10.7295 12.5829 10.9163 12.397 10.9163 12.1665V9.92427L13.1859 8.7891C13.3913 8.68598 13.4749 8.43599 13.3718 8.22973C13.2694 8.02427 13.0187 7.94066 12.8132 8.04379L10.4992 9.20083L8.18599 8.04379C7.97975 7.94066 7.72975 8.02426 7.62661 8.22973C7.52427 8.43597 7.60708 8.68597 7.81333 8.78911L10.0827 9.92427Z"
                fill="#141414"
              />
            </>
          ),
        }
      case 'ar-2':
        return {
          width: 19,
          height: 19,
          icon: (
            <>
              <path
                d="M0.5 5.75V1.5C0.5 0.947715 0.947715 0.5 1.5 0.5H5.54"
                stroke="black"
                strokeLinecap="round"
              />
              <path
                d="M5.54 18.5H1.5C0.947717 18.5 0.5 18.0523 0.5 17.5L0.5 13.25"
                stroke="black"
                strokeLinecap="round"
              />
              <path
                d="M18.5 13.25V17.5C18.5 18.0523 18.0523 18.5 17.5 18.5H13.46"
                stroke="black"
                strokeLinecap="round"
              />
              <path
                d="M13.46 0.5L17.5 0.5C18.0523 0.5 18.5 0.947715 18.5 1.5V5.75"
                stroke="black"
                strokeLinecap="round"
              />
              <path
                d="M5.24992 7.08816L8.90751 4.54816C9.27705 4.29154 9.77247 4.31329 10.1181 4.60131L13.1005 7.08665C13.3285 7.27664 13.4603 7.55809 13.4603 7.85487V11.009C13.4603 11.3058 13.3285 11.5873 13.1005 11.7773L10.1181 14.2626C9.77247 14.5506 9.27705 14.5724 8.90751 14.3157L5.24992 11.7757C4.98081 11.5889 4.82031 11.282 4.82031 10.9544V7.90953C4.82031 7.5819 4.98081 7.27504 5.24992 7.08816Z"
                stroke="black"
                strokeLinecap="round"
              />
              <path
                d="M8.70409 8.87861L5.99136 8.40765C5.37984 8.30149 4.82031 8.77224 4.82031 9.39292V10.954C4.82031 11.2817 4.98081 11.5885 5.24992 11.7754L7.96264 13.6592C8.62575 14.1197 9.53304 13.6452 9.53304 12.8379V9.86387C9.53304 9.37759 9.18321 8.96179 8.70409 8.87861Z"
                fill="black"
              />
            </>
          ),
        }
      case 'sample-2':
        return {
          width: 25,
          height: 25,
          icon: (
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M13.4504 4.19883C13.4504 3.83984 13.1594 3.54883 12.8004 3.54883C12.4414 3.54883 12.1504 3.83984 12.1504 4.19883V11.5488H4.80039C4.44141 11.5488 4.15039 11.8398 4.15039 12.1988C4.15039 12.5578 4.44141 12.8488 4.80039 12.8488H12.1504V20.1988C12.1504 20.5578 12.4414 20.8488 12.8004 20.8488C13.1594 20.8488 13.4504 20.5578 13.4504 20.1988V12.8488H20.8004C21.1594 12.8488 21.4504 12.5578 21.4504 12.1988C21.4504 11.8398 21.1594 11.5488 20.8004 11.5488H13.4504V4.19883Z"
              fill="#141414"
            />
          ),
        }
      case 'wishlist':
        return {
          width: 24,
          height: 24,
          icon: (
            <path
              d="M5.33337 18.2338V5C5.33337 4.44772 5.78109 4 6.33337 4H17.6667C18.219 4 18.6667 4.44772 18.6667 5V18.2338C18.6667 19.0111 17.8187 19.4912 17.1522 19.0913L12.5145 16.3087C12.1979 16.1187 11.8022 16.1187 11.4855 16.3087L6.84787 19.0913C6.18135 19.4912 5.33337 19.0111 5.33337 18.2338Z"
              stroke="currentColor"
              strokeWidth="1.5"
            />
          ),
        }
      default:
        return { icon: null }
    }
  }

  const { icon, width, height } = selectIcon()
  if (!icon) return null
  return (
    <svg
      name={name}
      className={className}
      viewBox={viewBox ? viewBox : `0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      width={setWidth || width}
      height={setHeight || height}
      style={{ color: 'inherit', ...style }}
    >
      {icon}
    </svg>
  )
}

export default ProductCardIcon
